import * as yup from 'yup';
import { SuggestionSchema } from '../../../common';
import { BaseFormSchema, UpdateBaseFormSchema } from '../../../common/IBaseForm';
import {
  AnswerForDoctorSchema,
  QuestionForDoctorSchema,
} from '../../../common/IQuestionOrAnswerForDoctor';

export const VisitSheetFormSchema = yup.object({
  question: QuestionForDoctorSchema.required(),
  answer: AnswerForDoctorSchema.optional().default(undefined),
});
export type IVisitSheetForm = yup.InferType<typeof VisitSheetFormSchema>;

export const CreateVisitSheetFormSchema = BaseFormSchema.concat(VisitSheetFormSchema);
export type ICreateVisitSheetForm = yup.InferType<typeof CreateVisitSheetFormSchema>;

export const UpdateVisitSheetFormSchema = UpdateBaseFormSchema.concat(VisitSheetFormSchema);
export type IUpdateVisitSheetForm = yup.InferType<typeof UpdateVisitSheetFormSchema>;

export const VisitSheetSuggestionSchema = yup.object({
  question: SuggestionSchema,
  answer: SuggestionSchema,
});

export type IVisitSheetSuggestion = yup.InferType<typeof VisitSheetSuggestionSchema>;
